export const payrollTags = ['Payroll'];
